import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PaymentProcessingPageRoutingModule } from './payment-processing-routing.module';

import { PaymentProcessingPage } from './payment-processing.page';

import { SalonMonsterDatePickerModule } from '../../components/smr-date-picker/smr-date-picker.module';
import { SharedModule } from '../../shared.module';
import { TableModule } from "primeng/table";
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PaymentProcessingPageRoutingModule,
    SalonMonsterDatePickerModule,
    SharedModule,
    TableModule,
    SalonMonsterLoadMaskModule
  ],
  declarations: [PaymentProcessingPage]
})
export class PaymentProcessingPageModule {}
